import { Fetch, GlobalInfo } from '@loca/mfe-vue3'
import envConfig from './envConfig'

const { APP_ID, BASE_API } = envConfig
const { version } = require('../../package.json')

GlobalInfo.set('fetch', Fetch.genFetch(`${BASE_API}/pe/gatekeeper`, {
  needAuth: true,
  commonParams: { appId: APP_ID, appVer: version },
}))

export const fetchBackend = Fetch.genFetch(BASE_API, {
  needAuth: true,
  commonParams: { appId: APP_ID, appVer: version },
})
